// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","745":"component---src-pages-privacy-js"}[chunkId] || chunkId) + "-" + {"293":"64d0699e75f01842410f","454":"87f5539bee8ce0b8155e","745":"3dc9c042a671fe179de7"}[chunkId] + ".js";
};